<script setup>
import { ref } from "vue";
import Accordion from "@/components/Accordion.vue";
import { useHead } from "@vueuse/head";

// Define page-specific metadata
useHead({
  title: "PESONA 2026 - UTDI",
  meta: [
    {
      name: "description",
      content:
        "Pertanyaan yang sering diajukan tentang kegiatan PESONA 2026 - Penyambutan mahasiswa baru Universitas Teknologi Digital Indonesia (UTDI).",
    },
    {
      property: "og:title",
      content: "PESONA 2026 - UTDI | FAQ",
    },
    {
      property: "og:description",
      content:
        "Pertanyaan yang sering diajukan tentang kegiatan PESONA 2026 - Penyambutan mahasiswa baru Universitas Teknologi Digital Indonesia (UTDI).",
    },
    {
      name: "keywords",
      content:
        "FAQ PESONA UTDI, pertanyaan tentang PESONA, informasi peserta PESONA 2026, ketentuan PESONA UTDI",
    },
  ],
});

// State untuk melacak FAQ yang terbuka
const openIndex = ref(null);

// Handler untuk toggle FAQ
const handleToggle = (index) => {
  // Jika FAQ yang diklik sudah terbuka, tutup semua
  // Jika tidak, buka FAQ yang diklik
  openIndex.value = openIndex.value === index ? null : index;
};

const faqs = [
  {
    q: "Almamaternya gimana ya kak? dibagikan kapan?",
    a: "Almamater, PDL di informasikan melalui email masing-masing ya",
  },
  {
    q: "Ketentuan sepatu bagaimana kak? warna yang diperbolehkan?",
    a: "Warna sepatu bebas yang penting tidak nabrak dari outfitnya, kami sarankan warna hitam yang netral",
  },
  {
    q: "Baju untuk perkenalan video apa ya kak?",
    a: "Baju bisa pake lurik / Baju putih ya kak",
  },
  {
    q: "Tugas bagaimana kak? Apakah individu semua?",
    a: "Tugas nya ada yang individu yang perkenalan ya kak, untuk 3 tugas nya di jelasin pada saat pesonanya",
  },
  {
    q: "Kemeja putih boleh pendek ga kak?",
    a: "Tidak boleh kawan, kemeja putih wajib panjang ya",
  },
];
</script>

<template>
  <section id="faq" class="py-16">
    <div class="container mx-auto px-5 lg:px-6 max-w-[1380px]">
      <h2
        class="text-3xl font-bold text-center text-primary mb-10"
        data-aos="zoom-in"
      >
        FAQ
      </h2>
      <div class="max-w-3xl mx-auto" data-aos="fade-up" data-aos-delay="200">
        <Accordion
          v-for="(item, index) in faqs"
          :key="index"
          :question="item.q"
          :answer="item.a"
          :is-open="openIndex === index"
          :aos-delay="300 + index * 100"
          @toggle="handleToggle(index)"
        />
      </div>

      <!-- FAQ Lainnya Link -->
      <div class="mt-8 text-center" data-aos="fade-up" data-aos-delay="800">
        <a
          href="https://docs.google.com/document/d/1ET3RKHhyS-GeFPoOU4XTAFVoDzwZfk88dm_WzKnlPAg/edit?usp=sharing"
          target="_blank"
          class="inline-flex items-center gap-2 bg-primary hover:bg-accent text-white px-6 py-3 rounded-lg font-semibold transition-colors duration-200"
        >
          FAQ Lainnya
        </a>
      </div>
    </div>
  </section>
</template>
